module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/3-5d854577da6f45956b39fca58e0277f7.jpg";